import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxDataGridModule,
  DxPopupModule,
  DxTextBoxModule,
  DxHtmlEditorModule,
  DxToastModule,
  DxFileUploaderModule,
  DxTooltipModule,
} from "devextreme-angular";
import { ContactsAddCompanyComponent } from "../contacts-add-company/contacts-add-company.component";
import { ContactsAddPersonComponent } from "../contacts-add-person/contacts-add-person.component";
import { CommentService } from "src/app/services/comment.service";
import { AppGlobals } from "../../app.globals";
import { SharedPipesModule } from "src/app/pipes/shared.pipes.module";
import { FileViewerComponent } from "../file-viewer/file-viewer.component";
import { GridConnectionComponent } from "src/app/pages/grid-connection/grid-connection.page";
import { DeletePopupComponent } from "../delete-popup/delete-popup.component";
import { ProjectPage } from "src/app/pages/grid-connection/project/project.page";
import { LoggingService } from "src/app/services/logging.service";
import { initialsOf, UserAvatarComponent } from "../user-avatar/user-avatar.component";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { GpdButtonComponent } from "../gpd-button/gpd-button.component";
import { Router } from "@angular/router";
import { FileViewerService } from "src/app/services/file-viewer.service";
import { AppConfig } from "src/app/app.config";
import { ConfigService } from "src/app/services/config.service";

//import { BrowserModule } from '@angular/platform-browser';
//BrowserModule,
@Component({
    selector: "app-comment-editor",
    imports: [
        CommonModule,
        SharedPipesModule,
        DxPopupModule,
        DxDataGridModule,
        DxButtonModule,
        DxTextBoxModule,
        ContactsAddCompanyComponent,
        ContactsAddPersonComponent,
        DxHtmlEditorModule,
        DxToastModule,
        DxFileUploaderModule,
        DxTooltipModule,
        FileViewerComponent,
        DeletePopupComponent,
        UserAvatarComponent,
        SvgIconComponent,
        GpdButtonComponent,
    ],
    templateUrl: "./comment-editor.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./comment-editor.component.css"]
})
export class CommentsEditorComponent implements OnInit {
  @ViewChild("commentFileInput") commentFileInput;

  @Input() commentId: number = null;
  @Input() siteId: number = null;
  @Input() projectId: number = null;
  @Input() taskId: number = null;

  @ViewChild(FileViewerComponent) fileViewer: FileViewerComponent;

  @Output() onCommentSaved = new EventEmitter();

  @Output() onCommentDeleted = new EventEmitter();

  commentText: string = "";
  commentList: any = [];
  hasExistingComments: boolean = false;
  toastVisible: boolean = false;

  addCommentButtonDisabled: boolean = true;

  isNewComment: boolean = false;
  commentHasFile: boolean = false;
  commentFileInfo: any = { Id: 0, Filename: "" };
  commentFileToDelete: number = 0;

  fileUploadData: any = null;
  commentDeletePopupVisible: any = false;
  itemToDelete: any;

  imageError: string = "";

  constructor(
    private commentService: CommentService,
    private loggingService: LoggingService,
    private router: Router,
    private fileViewerService: FileViewerService,
    private configService: ConfigService
  ) {}

  mentionableUsers$ = this.configService.userList$;
  readonly initialsOf = initialsOf;

  ngOnInit(): void {
    // console.clear();
    this.configService.loadUserList();
    this.resetForm();
    this.getComments();
  }

  customTooltips = {
    undo: $localize`Undo`,
    redo: $localize`Redo`,
    bold: $localize`Bold`,
    italic: $localize`Italic`,
    strike: $localize`Strikethrough`,
    underline: $localize`Underline`,
    alignLeft: $localize`Align Left`,
    alignCenter: $localize`Align Center`,
    alignRight: $localize`Align Right`,
    alignJustify: $localize`Justify`,
    orderedList: $localize`Ordered List`,
    bulletList: $localize`Bullet List`,
    color: $localize`Font Color`,
    background: $localize`Background Color`,
    link: $localize`Insert Link`,
    image: $localize`Insert Image`,
    clear: $localize`Clear Formatting`,
  };

  resetForm(): void {
    this.commentText = "";
    this.addCommentButtonDisabled = true;
    // this.toastVisible = false;
    this.commentHasFile = false;
    this.commentFileInfo = { Id: 0, Filename: "" };
    this.commentFileToDelete = 0;
  }

  checkCommentText(e: any): void {
    this.addCommentButtonDisabled = this.commentText.length <= 1;
  }

  getComments(): void {
    this.resetForm();
    this.hasExistingComments = false;
    this.commentList = [];

    let payload = {
      CommentItem: {
        GridConnectionId: this.siteId,
        ProjectId: this.projectId,
        TaskId: this.taskId,
        CommentData: [],
      },
    };

    this.commentService.getComments(payload).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          if (result.comments) {
            if (result.comments.commentData) {
              this.commentList = result.comments.commentData;
              this.hasExistingComments = this.commentList.length > 0;
            }
          }

          if (this.siteId != null) {
            if (GridConnectionComponent.GridConnectionComponentInstance != null)
              GridConnectionComponent.GridConnectionComponentInstance.RefreshCommentTabs();
          } else if (
            this.projectId != null &&
            (this.taskId == null || this.taskId == 0)
          ) {
            if (ProjectPage.ProjectPageInstance != null)
              ProjectPage.ProjectPageInstance.RefreshCommentTabs();
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  handleSubmit(): void {
    let payload = {
      CommentItem: {
        GridConnectionId: this.siteId,
        ProjectId: this.projectId,
        TaskId: this.taskId,
        CommentData: [
          {
            Id: null,
            CommentText: this.commentText,
            CommentAttachments: [],
          },
        ],
      },
    };

    this.commentService.addComment(payload).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          if (this.commentHasFile == true && this.commentFileInfo.Id == 0) {
            this.uploadCommemtFile(result.commentData.id);
          } else {
            this.toastVisible = true;
            this.getComments();
            this.onCommentSaved.emit(null);
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  onDrop(event: any) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const file = files.length > 0 ? files[0] : null;
    if (file) {
      const MaxFileNameLength = AppConfig.MaxFileNameLength;
      const invalidChars = /[\/:*?"<>|]/;
      const filename = file.name;

      // Check for empty filename
      if (!filename || filename.trim().length === 0) {
        AppGlobals.ShowErrorMessage(`Error: Filename cannot be empty.`);
        return;
      }

      // Check for filename length
      if (filename.length > MaxFileNameLength) {
        AppGlobals.ShowErrorMessage(
          `Error: Filename is too long. Maximum allowed length is ${MaxFileNameLength} characters.`
        );
        return;
      }

      // Check for invalid characters
      if (invalidChars.test(filename)) {
        AppGlobals.ShowErrorMessage(
          `Error: Filename contains invalid characters. Avoid using /:*?"<>|`
        );
        return;
      }

      this.setCommsFile(file);

      // this.onCommentDeleted.emit(this.taskId);
    }
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  triggerFileInput() {
    this.commentFileInput.nativeElement.click();
  }

  setCommsFile(file) {
    this.fileUploadData = file;
    if (file.name.length > AppConfig.MaxFileNameLength) {
      this.imageError = $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`;
      return;
    }else{
      this.imageError = "";
    }
    this.commentFileInfo = { Id: 0, Filename: file.name };
    this.commentHasFile = true;
  }

  openCommentFile(fileData: any): void {

    this.fileViewerService.openOrDownloadFile("comment-attachment", fileData.id, fileData.filename, "");

    return;
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  saveByteArray(reportName: string, fileType: string, byte: any) {
    let mimeType = "";

    switch (fileType) {
      case "png":
      case "jpeg":
      case "jpg":
        mimeType = `image/${fileType}`;
        break;
      case "csv":
      case "txt":
        mimeType = `text/${fileType}`;
        break;
      case "pdf":
      case "json":
      case "zip":
        mimeType = `application/${fileType}`;
        break;
      case "xls":
        mimeType = `application/vnd.ms-excel`;
        break;
      case "ppt":
        mimeType = `application/vnd.ms-powerpoint`;
        break;
      case "odt":
        mimeType = `application/vnd.oasis.opendocument.text`;
        break;
      case "pptx":
        mimeType = `application/vnd.openxmlformats-officedocument.presentationml.presentation`;
        break;
      case "xlsx":
        mimeType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        break;
      case "docx":
      case "doc":
        mimeType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        break;
    }

    var blob = new Blob([byte], { type: mimeType });
    let link = window.URL.createObjectURL(blob);

    if (reportName == null) {
      window.open(link).focus();
      return;
    }

    const anchorElement = document.createElement("a");
    document.body.appendChild(anchorElement);
    anchorElement.style.display = "none";

    anchorElement.href = link;
    anchorElement.download = reportName;
    anchorElement.click();

    window.URL.revokeObjectURL(link);
    anchorElement.remove();
  }

  removeCommentFile(): void {
    this.commentFileToDelete = this.commentFileInfo.Id;
    this.commentFileInfo = {};
    this.fileUploadData = null;
    this.commentFileToDelete = 0;
    this.commentHasFile = false;
  }

  uploadCommemtFile(commentId: number) {
    if (this.commentFileInfo == null) return;

    var formData = new FormData();
    formData.append("id", "0");
    formData.append("commentId", commentId.toString());
    //  formData.append("siteId", this.siteId.toString());
    formData.append("filename", this.fileUploadData.name);
    formData.append("filebytes", this.fileUploadData);
    formData.append("filebytesContentType", this.fileUploadData.type);

    this.commentService.addCommentAttachment(formData).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.getComments();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  initDelete(arg0: any) {
    this.commentDeletePopupVisible = true;
    this.itemToDelete = arg0;
  }

  deleteComment() {
    this.commentService
      .deleteComment({ commentId: this.itemToDelete })
      .then((result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.getComments();
          this.commentDeletePopupVisible = false;
          this.onCommentDeleted.emit(this.taskId);
        }
      });
  }
}
